export default {"src":"/_next/static/media/note-mod.334e50fd.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};